import React from 'react';
import { LuChevronRight } from 'react-icons/lu';

export default function IncidentDetailsDashboard() {
  // Data for Open Incidents Table
  const openIncidents = [
    { id: 'INC-022', incident: 'Customer slipped on wet floor', location: 'Dining Area', date: '16 Jul 2026', severity: 'Medium', daysOpen: '2 days' },
    { id: 'INC-019', incident: 'Raw food stored above ready-to-eat', location: 'Kitchen', date: '15 Jul 2026', severity: 'High', daysOpen: '3 days' },
    { id: 'INC-016', incident: 'Staff cut while using slicer', location: 'Kitchen', date: '13 Jul 2026', severity: 'High', daysOpen: '5 days' },
    { id: 'INC-011', incident: 'Refrigerator not maintaining temp', location: 'Kitchen', date: '10 Jul 2026', severity: 'Medium', daysOpen: '8 days' },
    { id: 'INC-004', incident: 'Fire exit door blocked', location: 'Front of House', date: '08 Jul 2026', severity: 'Medium', daysOpen: '10 days' },
  ];

  // Data for Overdue Incidents Table
  const overdueIncidents = [
    { id: 'INC-019', incident: 'Raw food stored above RTE', location: 'Kitchen', dueDate: '16 Jul 2026', daysOverdue: '2 days' },
    { id: 'INC-016', incident: 'Staff cut while using slicer', location: 'Kitchen', dueDate: '15 Jul 2026', daysOverdue: '3 days' },
  ];

  // Data for Incident Types Legend
  const incidentTypes = [
    { label: 'Food Safety', count: 8, percentage: '36%', color: 'bg-[#1e40af]' },
    { label: 'Customer Safety', count: 4, percentage: '18%', color: 'bg-[#ea580c]' },
    { label: 'Staff Injury', count: 3, percentage: '14%', color: 'bg-[#16a34a]' },
    { label: 'Equipment / Facilities', count: 3, percentage: '14%', color: 'bg-[#7c3aed]' },
    { label: 'Slip / Trip / Fall', count: 2, percentage: '9%', color: 'bg-[#0284c7]' },
    { label: 'Others', count: 2, percentage: '9%', color: 'bg-[#ec4899]' },
  ];

  return (
    <div className="w-full bg-slate-50 p-6 font-sans">
      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6 max-w-[1800px] mx-auto items-stretch">
        
        {/* Card 1: Open Incidents */}
        <div className="bg-white border border-slate-100 rounded-2xl p-5 shadow-sm min-h-[380px] flex flex-col justify-between">
          <div>
            <h2 className="text-[14px] font-bold text-indigo-950 mb-4">Open Incidents</h2>
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="bg-indigo-50/40 text-[9px] font-bold text-indigo-950/70 tracking-wider">
                    <th className="p-2.5 rounded-l-lg">ID</th>
                    <th className="p-2.5 w-[38%]">INCIDENT</th>
                    <th className="p-2.5">LOCATION</th>
                    <th className="p-2.5">DATE</th>
                    <th className="p-2.5 text-center">SEVERITY</th>
                    <th className="p-2.5 text-right rounded-r-lg">DAYS OPEN</th>
                  </tr>
                </thead>
                <tbody className="text-[11px] font-semibold text-slate-700 divide-y divide-slate-50">
                  {openIncidents.map((row, index) => (
                    <tr key={index} className="hover:bg-slate-50/40 transition-colors">
                      <td className="p-2.5 font-bold text-slate-400 whitespace-nowrap">{row.id}</td>
                      <td className="p-2.5 font-bold text-slate-800">{row.incident}</td>
                      <td className="p-2.5 text-slate-600">{row.location}</td>
                      <td className="p-2.5 text-slate-900 font-medium whitespace-nowrap">{row.date}</td>
                      <td className="p-2.5 text-center">
                        <span className={`inline-block px-1.5 py-0.5 rounded text-[10px] font-bold border ${
                          row.severity === 'High' 
                            ? 'bg-rose-50 text-rose-600 border-rose-100' 
                            : 'bg-orange-50 text-orange-600 border-orange-100'
                        }`}>
                          {row.severity}
                        </span>
                      </td>
                      <td className="p-2.5 text-right font-bold text-rose-600 whitespace-nowrap">{row.daysOpen}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <button className="mt-4 flex items-center justify-start gap-1 w-fit text-[11px] font-bold text-blue-600 hover:text-blue-700 transition-colors py-1">
            <span>View all open incidents</span>
            <LuChevronRight className="text-xs stroke-[2.5]" />
          </button>
        </div>

        {/* Card 2: Overdue Incidents */}
        <div className="bg-white border border-slate-100 rounded-2xl p-5 shadow-sm min-h-[380px] flex flex-col justify-between">
          <div>
            <h2 className="text-[14px] font-bold text-indigo-950 mb-4">Overdue Incidents</h2>
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="bg-indigo-50/40 text-[9px] font-bold text-indigo-950/70 tracking-wider">
                    <th className="p-2.5 rounded-l-lg">ID</th>
                    <th className="p-2.5 w-[42%]">INCIDENT</th>
                    <th className="p-2.5">LOCATION</th>
                    <th className="p-2.5">DUE DATE</th>
                    <th className="p-2.5 text-right rounded-r-lg">DAYS OVERDUE</th>
                  </tr>
                </thead>
                <tbody className="text-[11px] font-semibold text-slate-700 divide-y divide-slate-50">
                  {overdueIncidents.map((row, index) => (
                    <tr key={index} className="hover:bg-slate-50/40 transition-colors">
                      <td className="p-2.5 font-bold text-slate-400 whitespace-nowrap">{row.id}</td>
                      <td className="p-2.5 font-bold text-slate-800">{row.incident}</td>
                      <td className="p-2.5 text-slate-600">{row.location}</td>
                      <td className="p-2.5 text-slate-900 font-medium whitespace-nowrap">{row.dueDate}</td>
                      <td className="p-2.5 text-right font-bold text-rose-600 whitespace-nowrap">{row.daysOverdue}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <button className="mt-4 flex items-center justify-start gap-1 w-fit text-[11px] font-bold text-blue-600 hover:text-blue-700 transition-colors py-1">
            <span>View all overdue</span>
            <LuChevronRight className="text-xs stroke-[2.5]" />
          </button>
        </div>

        {/* Card 3: Incident Types Donut Chart View */}
        <div className="bg-white border border-slate-100 rounded-2xl p-5 shadow-sm min-h-[380px] flex flex-col justify-between">
          <div>
            <h2 className="text-[14px] font-bold text-indigo-950 mb-4">Incident Types</h2>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mt-4">
              
              {/* CSS Pure Conic Donut Chart Simulation */}
              <div className="relative w-36 h-36 rounded-full flex items-center justify-center flex-shrink-0"
                style={{
                  background: 'conic-gradient(#1e40af 0% 36%, #ea580c 36% 54%, #16a34a 54% 68%, #7c3aed 68% 82%, #0284c7 82% 91%, #ec4899 91% 100%)'
                }}
              >
                {/* Inner Card Cutout Hole */}
                <div className="absolute w-[72%] h-[72%] bg-white rounded-full flex flex-col items-center justify-center shadow-inner text-center">
                  <span className="text-2xl font-extrabold text-indigo-950 leading-none">22</span>
                  <span className="text-[10px] font-bold text-slate-400 mt-1 tracking-wide uppercase">Total Incidents</span>
                </div>
              </div>

              {/* Legend Meta List */}
              <div className="flex flex-col gap-2 w-full sm:w-auto min-w-[170px]">
                {incidentTypes.map((item, index) => (
                  <div key={index} className="flex items-center justify-between text-[11px] font-semibold text-slate-700">
                    <div className="flex items-center gap-2">
                      <span className={`w-2.5 h-2.5 rounded-full ${item.color} flex-shrink-0`} />
                      <span className="text-slate-800 truncate max-w-[110px]">{item.label}</span>
                    </div>
                    <span className="text-slate-900 font-bold ml-2 whitespace-nowrap">
                      {item.count} <span className="text-slate-400 font-medium text-[10px]">({item.percentage})</span>
                    </span>
                  </div>
                ))}
              </div>

            </div>
          </div>
          <button className="mt-4 flex items-center justify-start gap-1 w-fit text-[11px] font-bold text-blue-600 hover:text-blue-700 transition-colors py-1">
            <span>View all incident types</span>
            <LuChevronRight className="text-xs stroke-[2.5]" />
          </button>
        </div>

      </div>
    </div>
  );
}
